export default {
  en: {
    title: "",
  },
  pl: {
  gdansk: {
    title: "Gdańsk",
    address: "Hevelianum Dom Zdrojowy: Zdrojowa 2, 80-515 Gdańsk",
    desc: "Dom Zdrojowy usytuowany jest w Gdańsku, w dzielnicy Brzeźno, przy ulicy Zdrojowej. Architektura to XIX-wieczny odrestaurowany kurhaus, otoczony ogrodem i parkiem o powierzchni 8000 m kw., jest nadmorską filią Hevelianum. Na co dzień Dom Zdrojowy jest miejscem edukacji ekologicznej.",
  },
  slupsk: {
    title: "Słupsk",
    address: "Słupski Inkubator Technologiczny: Portowa 13, 76-200 Słupsk",
    desc: "Słupski Inkubator Technologiczny dysponuje nowoczesnym Centrum Szkoleniowo-Konferencyjnym. Organizuje szkolenia, warsztaty i inne wydarzenia. Oferta SIT skierowana jest do przedsiębiorców rozpoczynających działalność gospodarczą - start-up oraz przedsiębiorców już funkcjonujących na rynku o dużym potencjale wzrostu lub planujących wdrożenie innowacji."
  }
  },
}
